const Role = {
  ADMIN: 'Admin',
  USER: 'client',
  GUEST: 'guest',
};

export default Role;
